import WebService from "../../WebService"


const Company = {
    gets(params) {
        return WebService.get("/console/contest/companies?" + params)
    },
    upload(id, data) {
        return WebService.post("/console/contest/companies/" + id, data)
    }
}
export default Company